import { classNameTag } from '../../../utils/class-name-tag';
const modalTag = (...parts) => classNameTag('Modal', ...parts);
const modalSize = (size) => size;
export const ModalTags = {
    content: modalTag('content'),
    overlay: modalTag('overlay'),
    size: modalSize,
};
//# sourceMappingURL=class-name-tags.js.map